module.exports = __webpack_public_path__ + "static/media/note.e4fa917f.PNG";